/**
 * Classic Blue Theme - 经典蓝色主题
 * 原有风格，专业稳重的蓝色系
 */

export const classicBlueTheme = {
  name: 'classic',
  displayName: {
    zh: '经典蓝色',
    en: 'Classic Blue'
  },
  
  // CSS 变量定义
  cssVariables: {
    // ===== 背景色 =====
    '--theme-bg-primary': '#ffffff',
    '--theme-bg-secondary': '#f8f9fa',
    '--theme-bg-card': '#ffffff',
    '--theme-bg-elevated': '#ffffff',
    '--theme-bg-nav': '#1a3c6c',
    '--theme-bg-footer': '#003366',
    '--theme-bg-hero': 'linear-gradient(135deg, #1a3c6c 0%, #2c5f9e 100%)',
    
    // ===== 强调色 =====
    '--theme-accent-primary': '#1a3c6c',
    '--theme-accent-secondary': '#2c5f9e',
    '--theme-accent-highlight': '#FFD700',
    '--theme-accent-danger': '#C5003D',
    '--theme-accent-success': '#28a745',
    '--theme-accent-gradient': 'linear-gradient(135deg, #1a3c6c 0%, #2c5f9e 100%)',
    '--theme-accent-cta': 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
    
    // ===== 文字色 =====
    '--theme-text-primary': '#343a40',
    '--theme-text-secondary': '#6c757d',
    '--theme-text-muted': '#adb5bd',
    '--theme-text-on-dark': '#ffffff',
    '--theme-text-on-accent': '#ffffff',
    '--theme-text-link': '#1a3c6c',
    '--theme-text-link-hover': '#114575',
    
    // ===== 边框色 =====
    '--theme-border-primary': '#dee2e6',
    '--theme-border-secondary': '#e9ecef',
    '--theme-border-accent': '#1a3c6c',
    '--theme-border-light': 'rgba(255, 255, 255, 0.3)',
    
    // ===== 阴影 =====
    '--theme-shadow-sm': '0 2px 4px rgba(0, 0, 0, 0.1)',
    '--theme-shadow-md': '0 4px 8px rgba(0, 0, 0, 0.12)',
    '--theme-shadow-lg': '0 8px 16px rgba(0, 0, 0, 0.15)',
    '--theme-shadow-xl': '0 12px 24px rgba(0, 0, 0, 0.2)',
    '--theme-shadow-card': '0 2px 12px rgba(0, 0, 0, 0.08)',
    '--theme-shadow-card-hover': '0 8px 24px rgba(0, 0, 0, 0.12)',
    '--theme-shadow-nav': '0 2px 10px rgba(0, 0, 0, 0.2)',
    '--theme-shadow-cta': '0 4px 12px rgba(255, 215, 0, 0.3)',
    '--theme-shadow-cta-hover': '0 8px 20px rgba(255, 215, 0, 0.4)',
    
    // ===== 导航栏专用 =====
    '--theme-nav-bg': '#1a3c6c',
    '--theme-nav-text': '#ffffff',
    '--theme-nav-text-hover': '#FFD700',
    '--theme-nav-dropdown-bg': '#e2e6eb',
    '--theme-nav-dropdown-text': '#1a3c6c',
    '--theme-nav-dropdown-hover': 'rgba(26, 60, 108, 0.1)',
    
    // ===== 按钮样式 =====
    '--theme-btn-primary-bg': 'linear-gradient(135deg, #1a3c6c 0%, #2c5f9e 100%)',
    '--theme-btn-primary-text': '#ffffff',
    '--theme-btn-cta-bg': 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
    '--theme-btn-cta-text': '#1a3c6c',
    
    // ===== 卡片样式 =====
    '--theme-card-bg': '#ffffff',
    '--theme-card-border': '#dee2e6',
    '--theme-card-border-top': '#1a3c6c',
    '--theme-card-radius': '12px',
    
    // ===== 统计数据区域 =====
    '--theme-stat-number': '#1a3c6c',
    '--theme-stat-label': '#555555',
    '--theme-stat-bg': '#ffffff',
    
    // ===== 表单元素 =====
    '--theme-input-bg': '#ffffff',
    '--theme-input-border': '#e2e6eb',
    '--theme-input-focus-border': '#1a3c6c',
    '--theme-input-focus-shadow': '0 0 0 3px rgba(26, 60, 108, 0.1)',
    
    // ===== 排版 =====
    '--theme-font-heading': "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    '--theme-font-body': "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    
    // ===== 圆角 =====
    '--theme-radius-sm': '4px',
    '--theme-radius-md': '8px',
    '--theme-radius-lg': '12px',
    '--theme-radius-xl': '16px',
    '--theme-radius-full': '30px',
    
    // ===== 过渡动画 =====
    '--theme-transition-fast': '0.2s ease',
    '--theme-transition-normal': '0.3s ease',
    '--theme-transition-slow': '0.5s ease',
  }
};

export default classicBlueTheme;
